import { PaginatedDataDTO } from "@bottega52/commons-pagination";
import { Button, Card } from "@material-ui/core";
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import WarningIcon from '@material-ui/icons/Warning';
import * as React from "react";
import { ConnectedProps, connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as CreditsActions from '../../redux/credits/credits.actions';
import * as ModalsActions from '../../redux/modals/modals.actions';
import * as SettingsActions from '../../redux/settings/settings.actions';
import { IState } from '../../redux/store';
import { ICustomerContractInDTO } from "../../repository/jago/model/input/ICustomerContractInDTO";
import { ICustomerContractLegalDocumentInDTO } from "../../repository/jago/model/input/ICustomerContractLegalDocumentInDTO";
import { ICustomerInDTO } from "../../repository/jago/model/input/ICustomerInDTO";
import AbilityProvider from "../../services/PermissionService/AbilityProvider";
import { PERMISSIONS } from "../../services/PermissionService/PermissionConstants";
import { FileSelectData } from "../Modals/FileSelectModal";
import { ModalTypes } from "../Modals/ModalTypes";
import ReduxLanguage from "../ReduxLanguage";
import CustomerContractDocumentsTable from "./CustomerContractDocumentsTable";

const styles = createStyles({
  container: {
    display: 'flex',
    marginTop: 20,
    flexDirection: 'column',
  },
  cardContainer: {
    padding: 10,
    borderLeft: '3px solid #5AC0B1',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  icon: {
    marginRight: 5,
    width: 25,
  },
  title: {
    fontWeight: 'bold'
  },
  tableContainer: {
    display: 'flex',
    backgroundColor: 'white',
    height: 'calc(100vh - 380px)',
    width: '100%',
    marginTop: 10
  }
});

export interface ICustomerContractDocumentsSectionState {
  pageSize: number;
}

type IReduxProps = ConnectedProps<typeof connector> & RouteComponentProps<any>;

export interface ICustomerContractDocumentsSectionProps extends WithStyles<typeof styles> {
  language: string;
  customer: ICustomerInDTO;
}

export type ComponentProps = ICustomerContractDocumentsSectionProps & IReduxProps;

class CustomerContractDocumentsSection extends React.Component<ComponentProps, ICustomerContractDocumentsSectionState> {

  constructor(props: ComponentProps) {
    super(props);
    this.state  = {
      pageSize: 100
    };
  }

  addDocumentRequest() {
    const { dispatch, } = this.props;
    dispatch<any>(ModalsActions.showModal(`ADD_DOCUMENT_CONFIRM_MODAL`, {
      modalType: ModalTypes.FILE_SELECT_MODAL,
      modalProps: {
        icon: <InsertDriveFileOutlinedIcon style={{ width: 25 }} />,
        fieldLabel: 'credits.documentName',
        fileNamePlaceholder: 'credits.documentName',
        initialFileName: '',
        titleMessageKey: 'credits.addDocument',
        fileNameLabel: 'credits.documentName',
        successMessageKey: 'credits.addDocumentMessage',
        confirmMessageKey: 'forms.confirm',
        cancelMessageKey: 'forms.cancel',
        onConfirm: (value: FileSelectData) => {if (!(value as FileSelectData).file) return; this.addDocumentConfirm((value as FileSelectData).fileName, (value as FileSelectData).file)},
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`ADD_DOCUMENT_CONFIRM_MODAL`)),
      }
    }));
  }

  toBase64 = (file: File) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Rimuovo la prima parte, i.e. "data:application/pdf;base64,"
      let resultAsString = (reader.result as string);
      let resultSplitted = resultAsString.split(',');
      if (resultSplitted.length>1)
        resolve(resultSplitted[1])
    };
    reader.onerror = reject;
  });

  async addDocumentConfirm(documentName: string, document: File) {
    const { dispatch, selectedCustomerContract } = this.props;
    try {
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      const customerContractData = selectedCustomerContract as ICustomerContractInDTO;
      const fileBase64 = await this.toBase64(document);
      const extension = document.name.split('.').pop();
      await dispatch<any>(CreditsActions.createNewCustomerContractLegalDocument(customerContractData.customerId, customerContractData.id, {fileName: documentName + '.' + extension, file: fileBase64}));
      const updatedContracts = await dispatch<any>(CreditsActions.fetchCustomerContracts({ page: 0, pageSize: 1000, customerId: customerContractData.customerId }));
      const updatedContractsData = (updatedContracts as PaginatedDataDTO<ICustomerContractInDTO>).content;
      const updatedContract = updatedContractsData.find(contract => contract.id === customerContractData.id);
      if (updatedContract) {
        dispatch<any>(CreditsActions.setSelectedCustomerContract(updatedContract));
      }
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      await dispatch<any>(ModalsActions.hideModal('ADD_DOCUMENT_CONFIRM_MODAL'));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_OPPORTUNITYOWNER_EDIT`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'credits.addDocumentToContractError',
        }
      }));
    }
  }

  onDeleteContractDocumentRequest(contractDocument: ICustomerContractLegalDocumentInDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`DELETE_CONTRACT_DOCUMENT_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'forms.warning',
        successMessageKey: 'credits.deleteContractDocumentConfirm',
        confirmMessageKey: 'forms.confirm',
        cancelMessageKey: 'forms.cancel',
        onConfirm: () => this.onDeleteContractDocumentConfirm(contractDocument),
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`DELETE_CONTRACT_DOCUMENT_CONFIRM_MODAL`)),
      }
    }));
  }

  async onDeleteContractDocumentConfirm(contractDocument: ICustomerContractLegalDocumentInDTO) {
    const { dispatch, selectedCustomerContract } = this.props;
    try {
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      const customerContractData = selectedCustomerContract as ICustomerContractInDTO;
      await dispatch<any>(CreditsActions.deleteCustomerContractLegalDocument(customerContractData.customerId, customerContractData.id, contractDocument.fileName));
      const updatedContracts = await dispatch<any>(CreditsActions.fetchCustomerContracts({ page: 0, pageSize: 1000, customerId: customerContractData.customerId }));
      const updatedContractsData = (updatedContracts as PaginatedDataDTO<ICustomerContractInDTO>).content;
      const updatedContract = updatedContractsData.find(contract => contract.id === customerContractData.id);
      if (updatedContract) {
        dispatch<any>(CreditsActions.setSelectedCustomerContract(updatedContract));
      }
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.hideModal('DELETE_CONTRACT_DOCUMENT_CONFIRM_MODAL'));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_CONTRACT_DOCUMENT_DELETE`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'credits.deleteContractDocumentError',
        }
      }));
    }
  }

  onDownloadContractDocumentRequest(contractDocument: ICustomerContractLegalDocumentInDTO) {
    const fileUrl = contractDocument.fileUrl;
    const a = document.createElement('a');
    a.href = fileUrl;
    a.download = contractDocument.fileName;
    a.click();
  }
  
  public render() {
    const { selectedCustomerContract, classes } = this.props;
    const { pageSize } = this.state;
    
    const canEditCustomerContract = AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CONTRACTS_UPDATE)

    const customerContractDocuments = (selectedCustomerContract as ICustomerContractInDTO).legalDocuments || [];
    const customerContractDocumentsPaginated = {
      content: customerContractDocuments,
      pagination: {
        page: 0,
        pageSize: customerContractDocuments.length,
        totalPages: 1
      }
    } as PaginatedDataDTO<ICustomerContractLegalDocumentInDTO>;

    return (
      <div className={classes.container}>
        <Card className={classes.cardContainer}>
          <div className={classes.header}>
            <div className={classes.headerInner}>
              <InsertDriveFileOutlinedIcon className={classes.icon} />
              <h3 className={classes.title}>{<ReduxLanguage languageKey="credits.contractDocuments"/>}</h3>
              <h5 className={classes.title} style={{ marginLeft: 0 }}>{` (${customerContractDocuments.length})`}</h5>
            </div>
            {canEditCustomerContract && 
              <Button
                variant="contained"
                style={{ fontWeight: 'bold', backgroundColor: '#5AC0B1', fontSize: 11, color: 'white' }}
                onClick={() => {this.addDocumentRequest()}}
              >
                <ReduxLanguage languageKey="credits.associateNewDocumentToContract" />
              </Button>
            }
          </div>
          <div className={classes.tableContainer}>
            <CustomerContractDocumentsTable
              rowsPerPage={pageSize}
              customerDocuments={customerContractDocumentsPaginated}
              onRowClick={() => {}}
              onPageSizeChange={() => {}}
              onFetchElementsOnPage={() => {}}
              onDeleteContractDocumentRequest={(document) => this.onDeleteContractDocumentRequest(document)}
              onDownloadContractDocumentRequest={(document) => this.onDownloadContractDocumentRequest(document)}
            />
          </div>
        </Card>
      </div>
    );
  }
}


function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    userData: state.user.userData,
    selectedCustomerContract: state.credits.customerContracts.selectedCustomerContract,
    customerPlants: state.credits.systemCards.plants.data,
  };
}

const connector = connect(mapStateToProps);

export default connector(withRouter(withStyles(styles)(CustomerContractDocumentsSection)));